export default {
	name: "",
	plan_number: "",
	builder: 0,
	property: 0,
	elevations: [],
	base_prices: {},
	stories: 0,
	lot_types: [],
	arc_file: "",
	base_width_feet: "",
	base_width_inches: '',
	arc_builder_comments: '',
	masonry_percent: '',
	roof_pitch: '',
	height: "",
	arc_approved: [],
	sqft: '',
	garage: '',
	full_baths: '',
	half_baths: '',
	beds: '',
	classifications: [],
}